import React from 'react';

//import './index.css';
import styles from './Test.module.css';


const Test = () => {
	return (
		<div className={styles.test}>
			<h1>test</h1>		
		</div>
	);
}

export default Test;